import entitiesSearch from 'app/modules/search/sagas/entitiesSearch';
import rulesSearch from 'app/modules/search/sagas/rulesSearch';
import alertsSearch from 'app/modules/search/sagas/alertsSearch';
import txnEventsSearch from 'app/modules/search/sagas/txnEventsSearch';
import teamsSearch from 'app/modules/search/sagas/teamsSearch';

const sagaRegistry = [
  entitiesSearch,
  rulesSearch,
  alertsSearch,
  txnEventsSearch,
  teamsSearch,
];

export default sagaRegistry;
